<template>
    <div class="bg-slate-50 py-16 sm:py-24">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:text-center">
                <span
                    class="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-600/10">Why
                    us</span>
                <p
                    class="mt-4 text-pretty text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl lg:text-balance">
                    Best Arabic & The Quran Learning Experince
                </p>
            </div>
            <div class="mx-auto mt-12 max-w-2xl sm:mt-16 lg:mt-20 lg:max-w-none">
                <dl class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    <div v-for="feature in features" :key="feature.name"
                        class="group relative rounded-2xl bg-white p-8 ring-1 ring-slate-900/5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                        <div
                            class="flex size-12 items-center justify-center rounded-xl bg-primary-50 transition-colors group-hover:bg-primary-100">
                            <img v-if="feature.icon" :src="feature.icon" alt="" class="size-7" />
                        </div>
                        <dt class="mt-6 text-base font-semibold text-slate-900">
                            {{ feature.name }}
                        </dt>
                        <dd class="mt-2 text-base/7 text-slate-600">{{ feature.description }}</dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    ChatBubbleLeftEllipsisIcon,
    CalendarIcon,
    CursorArrowRaysIcon,
    CubeIcon,
    GlobeAltIcon,
    ArrowPathIcon, CloudArrowUpIcon, FingerPrintIcon, LockClosedIcon } from '@heroicons/vue/24/outline'

const features = [
    {
        name: 'Native Arabic Tutors',
        description: 'Our tutors are native Arabic speakers, ensuring an authentic learning experience.',
        icon: 'images/icons/features/arabic.png',
    },
    {
        name: 'Flexible Scheduling',
        description: 'Choose your own schedule and learn at your own pace.',
        icon: 'images/icons/features/calendar.png',
    },
    {
        name: 'Interactive Learning',
        description: 'Engaging lessons with interactive tools and resources.',
        icon: 'images/icons/features/chat.png',
    },
    {
        name: 'Certified Tutors',
        description: 'Al-Azhar certified professional teachers are available.',
        icon: 'images/icons/features/certified.png',
    },
    {
        name: 'Comprehensive Curriculum',
        description: 'A well-structured curriculum covering all aspects of Arabic and Quranic studies.',
        icon: 'images/icons/features/zip.png',
    },
    {
        name: '24/7 Support',
        description: 'Our support team is available around the clock to assist you.',
        icon: 'images/icons/features/support.png',
    },
]
</script>
